<template>
  <aside id="MainMenu" ref="MainContent">
    <div class="menu_container" data-lenis-prevent data-menu-box>
      <ol class="menu_list">
        <li
          v-for="(menu, menuIndex) in menuListData"
          :key="`menu_${menuIndex}`"
        >
          <a v-if="menu.Type == 'Link'" :href="menu.Link" target="_blank">
            <p class="title">
              {{ menu.Title
              }}<span class="material-symbols-rounded"> open_in_new </span>
            </p>
          </a>
          <router-link
            v-else-if="menu.Type == 'MenuItem' && !menu.ListKey"
            :to="menu.Link"
            @click.native="$emit('set-menu-status', false)"
          >
            <p class="title">{{ menu.Title }}</p>
            <span class="icon material-symbols-rounded"> east </span>
          </router-link>
          <a
            v-else-if="menu.Type == 'MenuItem' && menu.ListKey"
            @click="SetSubDrawer(menu.ListKey)"
          >
            <p class="title">{{ menu.Title }}</p>
            <span class="icon material-symbols-rounded"> east </span>
          </a>
        </li>
      </ol>
      <div class="info_box">
        <p class="phone_text">
          Tel {{ $store.getters.columnData("company_phone") }}
        </p>
        <p class="business_hours">
          {{ $store.getters.columnData("company_time") }}
        </p>
        <a
          target="_blank"
          :href="`tel://${$store.getters.columnData('company_phone')}`"
        >
          <p class="title">電話諮詢</p>
          <p class="sub_title">CONTACT US</p>
        </a>
      </div>

      <div
        class="sub_drawer social"
        :class="{ active: subDrawerList.includes('social_media') }"
      >
        <button class="back_button" @click="SetSubDrawer('social_media')">
          <span class="icon material-symbols-rounded"> west </span>社群媒體
        </button>
        <ol class="menu_list">
          <li>
            <a
              :href="$store.getters.columnData('company_facebook')"
              target="_blank"
            >
              <p class="title">
                Facebook<span class="material-symbols-rounded">
                  open_in_new
                </span>
              </p>
            </a>
          </li>
          <li>
            <a
              :href="$store.getters.columnData('company_instagram')"
              target="_blank"
            >
              <p class="title">
                Instagram<span class="material-symbols-rounded">
                  open_in_new
                </span>
              </p>
            </a>
          </li>
          <li>
            <a
              :href="$store.getters.columnData('company_line')"
              target="_blank"
            >
              <p class="title">
                LINE@<span class="material-symbols-rounded"> open_in_new </span>
              </p>
            </a>
          </li>
        </ol>
      </div>

      <!-- <div
        class="sub_drawer menu_category"
        :class="{ active: subDrawerList.includes('menu_category') }"
      >
        <button class="back_button" @click="SetSubDrawer('menu_category')">
          <span class="icon material-symbols-rounded"> west </span>認證二手車
        </button>
        <ol class="menu_list">
          <li
            v-for="(item, itemIndex) in menuCategoryData"
            :key="`menu_category_${itemIndex}`"
          >
            <a
              @click="
                (activeMenuCategory = item.MenuCategoryID),
                  SetSubDrawer('category')
              "
            >
              <p class="title">
                {{ item.Title }}
              </p>
              <span class="material-symbols-rounded"> east </span>
            </a>
          </li>
        </ol>
      </div> -->

      <div
        v-if="activeMenuCategoryData"
        class="sub_drawer category"
        :class="{ active: subDrawerList.includes('category') }"
      >
        <button class="back_button" @click="SetSubDrawer('category')">
          <span class="icon material-symbols-rounded"> west </span>
          {{ activeMenuCategoryData.Title }}
        </button>
        <ol class="menu_list">
          <li
            v-for="(item, itemIndex) in activeCategoryData"
            :key="`category_${itemIndex}`"
          >
            <router-link
              :to="`/collections?category=${item.MenuID}`"
              @click.native="$emit('set-menu-status', false)"
            >
              <p class="title">
                {{ item.Title }}
              </p>
              <span class="material-symbols-rounded"> east </span>
            </router-link>
          </li>
        </ol>
      </div>
    </div>
    <div class="background_box" data-menu-background></div>
  </aside>
</template>

<script>
import { MainMenu } from "@/animations/mainMenu";
export default {
  name: "MainMenu",
  props: {
    menuStatus: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      subDrawerList: [],
      activeMenuCategory: "",
      animation: null,
    };
  },
  methods: {
    InitAnimation() {
      this.animation = new MainMenu(this.$refs.MainContent);
      this.animation.Reset();
    },
    SetSubDrawer(key) {
      if (this.subDrawerList.includes(key)) {
        this.subDrawerList = this.subDrawerList.filter((item) => item !== key);
      } else {
        this.subDrawerList.push(key);
      }
    },
  },
  computed: {
    menuCategoryData() {
      const menuCategoryData = this.$store.state.menuCategoryData;
      return menuCategoryData ? menuCategoryData : [];
    },
    activeMenuCategoryData() {
      const categoryData = this.$store.state.menuCategoryData;
      if (categoryData == null) {
        return null;
      }

      return categoryData.find((item) => item.MenuCategoryID == 1);
    },
    activeCategoryData() {
      const categoryData = this.$store.state.categoryData;
      if (categoryData == null) {
        return [];
      }
      return categoryData.filter(
        (item) => item.MenuCategoryID == 1 && item.Content7 == "Y"
      );
      // return categoryData.filter(
      //   (item) =>
      //     item.MenuCategoryID == this.activeMenuCategory && item.Content7 == "Y"
      // );
    },
    menuListData() {
      return [
        {
          Title: "認證二手機車",
          SubTitle: "Scooters",
          Type: "MenuItem",
          Link: "/collections",
          ListKey: "category",
        },
        {
          Title: "線上機車估價",
          SubTitle: "Online Quote",
          Type: "Link",
          Link: this.$store.getters.columnData("menu_contact_link"),
        },
        {
          Title: "前往門市",
          SubTitle: "Visit Store",
          Type: "Link",
          Link: this.$store.getters.columnData("menu_navigation_link"),
        },
        {
          Title: "社群媒體",
          SubTitle: "Social Media",
          Type: "MenuItem",
          Link: "/social_media",
          ListKey: "social_media",
        },
        {
          Title: "最新消息",
          SubTitle: "News",
          Type: "MenuItem",
          Link: "/news",
        },
      ];
    },
  },
  watch: {
    menuStatus() {
      if (this.menuStatus) {
        this.animation.Open();
        document.querySelector("body").style.overflowY = "hidden";
      } else {
        this.animation.Close();
        this.subDrawerList = [];
        this.activeMenuCategory = "";
        document.querySelector("body").style.overflowY = "auto";
      }
    },
  },
  mounted() {
    this.InitAnimation();
    window.addEventListener("resize", () => {
      this.$emit("set-menu-status", false);
    });
  },
};
</script>
